<template>
  <div class="article-page">
    <div class="a-index-hero a-wrap-wide">
      <h1>Articles</h1>
      <p>Guides and stories on creating augmented reality art — WebAR how-tos, artist features, and practical tips.</p>
    </div>

    <div class="a-index-grid a-wrap-wide">
      <!-- Left-aligned grid: cards line up under the left-aligned page heading. -->
      <div v-if="articles.length" class="ej-card-grid">
        <ArticleCard v-for="a in articles" :key="a.slug" :article="a" />
      </div>
      <p v-else class="a-deck">No articles yet — check back soon.</p>
    </div>
  </div>
</template>

<script>
import ArticleCard from '../components/ArticleCard.vue'
import { publishedArticles } from '../articles/registry'

export default {
  name: 'ArticlesIndex',
  components: { ArticleCard },
  data () {
    return {
      articles: publishedArticles
    }
  }
}
</script>
